const mapStyle = require('../mapstyle-ol.json');
export default {
  init() {
    // JavaScript to be fired on all pages
    $('.btn-menu').on('click', function() {
      $('.nav-overlay').addClass('nav-overlay--active');
      $('body').addClass('modal-open');
    });

    $('.close-btn').on('click', function() {
      $('body').removeClass('modal-open');
      $('.nav-overlay').removeClass('nav-overlay--active');
    });

    $('.menu-item').on('click', function() {
      $('body').removeClass('modal-open');
    });

    if (!(typeof window.google === 'object' && window.google.maps)) {
      console.error('Google Maps API is not loaded, cannot display map.');
    } else {
      var $maps = $('.google-map');
      var mapsArr = [];
      var infoWindowsArr = [];
      var markersArr = [];
      var mapBoundsArr = [];

      $maps.each(function (mapIndex) {
        var $map = $(this);
        var $markers = $map.find('.marker');

        // Generic Victoria Fallback
        var center = new window.google.maps.LatLng(48.428522, -123.365682);

        // Use the first marker as the initial centre
        if ($markers.length > 0) {
          center = new window.google.maps.LatLng($markers.eq(0).data('lat'), $markers.eq(0).data('lng'));
        }

        // Make the map
        mapsArr[mapIndex] = new window.google.maps.Map($map[0], {
          zoom: 16,
          center: center,
          fullscreenControl: false,
          mapTypeControl: false,
          rotateControl: false,
          streetViewControl: false,
          scaleControl: false,
          styles: mapStyle,
        });

        // Make the infowindow for this map
        infoWindowsArr[mapIndex] = new window.google.maps.InfoWindow({
          maxWidth: 260,
        });

        // Bounds for this map
        mapBoundsArr[mapIndex] = new window.google.maps.LatLngBounds();

        // Process markers
        markersArr[mapIndex] = [];
        $markers.each(function(markerIndex) {
          var $marker = $(this);

          markersArr[mapIndex][markerIndex] = new window.google.maps.Marker({
            position: new window.google.maps.LatLng($marker.data('lat'), $marker.data('lng')),
            map: mapsArr[mapIndex],
            title: $marker.data('title'),
          });

          // Extend Bounds
          mapBoundsArr[mapIndex].extend(markersArr[mapIndex][markerIndex].position);

          // If there's content, put it in the infowindow
          if ($.trim($marker.html()).length > 0) {
            if (markerIndex === 0) {
              infoWindowsArr[mapIndex].setContent($marker.html());
              infoWindowsArr[mapIndex].open(mapsArr[mapIndex], markersArr[mapIndex][markerIndex]);
            }

            markersArr[mapIndex][markerIndex].addListener('click', function () {
              infoWindowsArr[mapIndex].setContent($marker.html());
              infoWindowsArr[mapIndex].open(mapsArr[mapIndex], markersArr[mapIndex][markerIndex]);
            });
          }
        });

        // Fit map to bounds and centre
        if (markersArr[mapIndex].length === 1) {
          mapsArr[mapIndex].setCenter(mapBoundsArr[mapIndex].getCenter());
        } else if (markersArr[mapIndex].length > 1) {
          mapsArr[mapIndex].fitBounds(mapBoundsArr[mapIndex]);
          mapsArr[mapIndex].panToBounds(mapBoundsArr[mapIndex]);
        }
      });
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js